import { v1 as uuid } from 'uuid';

interface IListener {
  id: string;
  keyCode: number;
  onKeyUp: (event: KeyboardEvent) => boolean;
}
export class HotkeyService {
  constructor() {
    this.listeners = [];
    this.isPaused = false;
    document.addEventListener('keyup', this.onKeyUp.bind(this), false);
  }

  isPaused: boolean;

  listeners: IListener[];

  subscribe(keyCode: number, callback: (event: KeyboardEvent) => boolean, id?: string) {
    const entry = {
      id: id || uuid(),
      keyCode,
      onKeyUp: callback,
    };
    const existingIdx = this.listeners.findIndex((x) => x.id === entry.id);
    if (existingIdx > -1) {
      this.listeners[existingIdx] = entry;
    } else {
      this.listeners.push(entry);
    }
    return entry.id;
  }

  unsubscribe(id: string) {
    const idx = this.listeners.findIndex((x) => x.id === id);
    if (idx > -1) {
      this.listeners.splice(idx, 1);
    }
  }

  unsubscribeAll() {
    this.listeners = [];
  }

  pause() {
    this.isPaused = true;
  }

  resume() {
    this.isPaused = false;
  }

  private onKeyUp(event: KeyboardEvent) {
    if (this.isPaused) {
      return;
    }
    const callbacks = this.listeners.filter((ls) => ls.keyCode === event.keyCode);
    for (let i = 0; i < callbacks.length; i++) {
      if (!callbacks[i].onKeyUp(event)) {
        break;
      }
    }
  }
}
